module.exports = __webpack_public_path__ + "img/sport-36-@3x.449e538e.png";